import Bar3Default from '../../lib/jin/svgchartlib/01_Charts/04_Bar_Solid/includes/primitives/Data'

export default Bar3Default